import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page88() {
  useEffect(() => {
    document.title = "Маяк — Страница 87"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page86" />
        <ForwardLink href="/page88" />
      </div>

      <p style={{ textAlign: "right" }}>87.</p>
      <p>Переворачивает несколько страниц.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        <i>Помощник отсутствует на посту. Предается<br/>
        привычному ‘рукоблудию’<br/>
        в сарае.</i>
      </p>
      <p>Еще несколько страниц.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        <i>Пьяный на службе.</i>
      </p>
      <p>Переворачивает страницу.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        <i>Бессвязная речь.</i>
      </p>
      <p>Еще одна страница.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        <i>Пытался покинуть свой пост.<br/>
        Нападение. Кража.</i>
      </p>
      <p>Еще одна страница.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        <u>Я</u> <u>не</u> <u>чувствую</u> <u>себя</u> <u>в</u> <u>безопасности</u> <u>с</u> <u>ним.</u><br/>
        <br/>
        <i>Рекомендую <u>увольнение без выплаты жалования</u></i>.<br/>
        <br/>
        УВОЛЬНЕНИЕ БЕЗ ВЫПЛАТЫ ЖАЛОВАНИЯ?!
      </p>
      <p>МОЛОДОЙ бросает в него ЖУРНАЛ.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Ты пытаешься погубить меня?! Я<br/>
        работяга! Я! Я работаю так же усердно, как любой другой<br/>
        мужчина!
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ты лжешь, Томас.
      </p>

      <p style={{ display: "flex" }}>
        <div>
          <div style={{ textAlign: "center" }}>МОЛОДОЙ</div>
          Остановись.
        </div>
        <div style={{ marginLeft: "auto" }}>
          <div style={{ textAlign: "center" }}>СТАРИК (ПРОДОЛЖЕНИЕ)</div>
          Ты лжешь самому себе, но<br/>
          боишься в этом признаться.
        </div>
      </p>
      <p>МОЛОДОЙ меняет тон:</p>
      <p style={{ textAlign: "right" }}>87.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page86" />
        <ForwardLink href="/page88" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710718036/the-lighthouse-script/arriyjcehzyihwxdfrg9.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page88;
